export default __webpack_public_path__ + "static/media/yellow-exclamation.afd697ab.svg";